var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-list"},[_vm._l((_vm.notifications),function(notification){return [_c('Notification',{key:notification.id,attrs:{"id":notification.id,"type":notification.type,"content":notification.content}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }